import React from "react";

import Lamina25img from "../images/lamina25img.png";
import Lamina25act from "../images/lamina25act.png";
import Lamina25act1 from "../images/lamina25act1.png";
import Lamina25act2 from "../images/lamina25act2.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  purple: {
    color: theme.palette.purple.main,
    borderColor: theme.palette.purple.main,
  },
  actDivider: {
    borderRight: "1px solid #ccc",
    [theme.breakpoints.down("md")]: {
      borderRight: "none",
    },
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
      },
    },
  },
}));

const Lamina25 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 25: ¿Quiénes nos gobiernan?"
        meta={[
          {
            property: "og:title",
            content: "Lámina 25: ¿Quiénes nos gobiernan?",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "En el Estado peruano hay distintos niveles de gobierno y cargos públicos.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="25" color="purple" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <Title title="¿Quiénes nos gobiernan?" color="purple" size="md" />
          </Grid>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <img src={Lamina25img} alt="Quiénes nos gobiernan" />
          </Grid>
        </Grid>

        <p>
          En el Estado peruano hay distintos niveles de gobierno y cargos
          públicos. Esta organización está descrita en la Constitución, que no
          solo nos dice cuáles son nuestros deberes y derechos, sino también
          quiénes se encargan de cada parte en el gobierno de nuestro país.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>
            Une con una línea de diferente color las funciones que corresponden
            a cada organismo de gobierno.
          </strong>
        </p>
        <img src={Lamina25act} alt="Actividad" />
        <p>
          Ahora completa esta lista con los nombres de las autoridades actuales.
        </p>
        <ul>
          <li>Presidente del Perú:</li>
          <li>Presidente del Congreso:</li>
          <li>Gobernador regional:</li>
          <li>Alcalde de tu distrito:</li>
          <li>Presidente del Poder Judicial:</li>
        </ul>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="EL PODER EJECUTIVO" color="purple" />
        <p>
          Es el que ejerce el gobierno en todo el país y garantiza el bienestar
          de todas las personas que habitan en el territorio peruano. Está
          encabezado por el presidente, quien designa a los ministros y a otras
          autoridades para gobernar el país.
        </p>
        <br></br>
        <Grid container className={classes.root} spacing={4} justify="center">
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={classes.actDivider}
          >
            <Actividad color="purple" />
            <p>
              <strong>
                Observa las imágenes y une mediante una línea el nombre del
                cargo con su función.
              </strong>
            </p>
            <img src={Lamina25act1} alt="Actividad" />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Actividad color="purple" />
            <p>
              <strong>
                Observa las imágenes de los representantes de dos ministerios.
                Luego, únelas mediante una línea con la imagen que representa la
                función que les corresponde.
              </strong>
            </p>
            <img src={Lamina25act2} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-25.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.purple }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 25: ¿Quiénes nos gobiernan?'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La democracia y las elecciones"
        anteriorEnlace="/lamina-1-24"
        siguiente="¿Qué hace el congreso?"
        siguienteEnlace="/lamina-1-26"
      />
    </>
  );
};

export default Lamina25;
